import { enqueueOaiq } from './sdk';
import { OpenAIPixelEventData } from './types';

export const trackOpenAIEvent = (
  eventName:
    | 'items_added'
    | 'checkout_started'
    | 'order_created'
    | 'contents_viewed',
  eventData?: OpenAIPixelEventData,
) => {
  enqueueOaiq('measure', eventName, eventData);
};
